import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import { CONTENT_RENDERER_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys/pageSegmentLoadKey.ts';
import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

export const CONTENT_RENDERER_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: CONTENT_RENDERER_SEGMENT_KEY,
	ssr: window.__SSR_RENDERED__ ? { doneAsFmp: true } : undefined,
	timings: [{ key: 'tti', endMark: 'tti' }],
});
